<template>
  <v-app>
    <!-- Navigation Bar -->
    <Navbar v-if="isLoggedIn" />
    
    <!-- Main Content -->
    <v-main>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>

    <!-- Notification Snackbar -->
    <v-snackbar
      v-model="showNotification"
      :color="notificationColor"
      :timeout="3000"
    >
      {{ notificationMessage }}
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'App',
  components: {
    Navbar
  },
  data() {
    return {
      showNotification: false,
      notificationMessage: '',
      notificationColor: 'success'
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'getNotification']),
    notification() {
      return this.getNotification
    }
  },
  watch: {
    notification(newVal) {
      if (newVal) {
        this.showNotification = true
        this.notificationMessage = newVal.message
        this.notificationColor = newVal.type
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
